import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredArticles = articles.filter((a) => a.featured);

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = featuredArticles.length;

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const article = featuredArticles[current];

  return (
    <section className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover transition-opacity duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 h-full flex flex-col justify-end pb-16 md:pb-20">
        <div className="w-full max-w-3xl">
          <div className="flex items-center gap-2 mb-3">
            <span className="px-3 py-1 text-xs font-bold bg-primary-500 text-white rounded-full whitespace-nowrap">
              置顶爆料
            </span>
            {article.hot && (
              <span className="px-3 py-1 text-xs font-bold bg-accent-500 text-white rounded-full whitespace-nowrap">
                HOT
              </span>
            )}
          </div>

          <Link to={`/article/${article.id}`} className="cursor-pointer">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-3 leading-tight font-heading hover:text-primary-200 transition-colors duration-300">
              {article.title}
            </h2>
          </Link>

          <p className="text-white/70 text-sm md:text-base mb-4 line-clamp-2 max-w-2xl">
            {article.excerpt}
          </p>

          <div className="flex items-center gap-4 text-white/50 text-xs md:text-sm mb-6">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.publishDate}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.readCount >= 10000 ? `${(article.readCount / 10000).toFixed(1)}万阅读` : `${article.readCount}阅读`}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {article.commentCount}评论
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {featuredArticles.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
                index === current ? 'bg-white w-6' : 'bg-white/40 hover:bg-white/70'
              }`}
            />
          ))}
        </div>

        <button
          onClick={prev}
          className="absolute left-4 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/30 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          onClick={next}
          className="absolute right-4 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/30 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>
      </div>
    </section>
  );
}